/* global $:false */
import animator from 'canvas-animator'
import resource from './resource'
import XiPart from './XiPart'
import * as global from '../global'

const X_MAX_WIDTH = 107
const X_NORMAL_WIDTH = 59
const X_SMALL_WIDTH = 42

const IMG_YELLOW_WIDTH = 50 * 3
const IMG_YELLOW_HEIGHT = 52 * 3
const IMG_RED_WIDTH = 50 * 3
const IMG_RED_HEIGHT = 52 * 3
const IMG_BLUE_WIDTH = 107 * 3
const IMG_BLUE_HEIGHT = 96 * 3

export default class Xi extends animator.base.ShapeContainer {
  constructor (context = null, x = 0, y = 0, canvasWidth, canvasHeight) {
    super(context, x, y)
    this.scale = global.scale
    $(document.body).on('mousemove', e => {
      XiPart.mousePosition.x = e.clientX - canvasWidth / 2
      XiPart.mousePosition.y = e.clientY - canvasHeight / 2
    })
    this.xs = []
    const initialScale = X_NORMAL_WIDTH / X_MAX_WIDTH
    const xWidth = X_MAX_WIDTH * initialScale
    const xHeight = 96 * initialScale
    const xWidthHalf = xWidth / 2
    const xHeightHalf = xHeight / 2
    const XiPartWidth = 50 * initialScale
    const XiPartHeight = 52 * initialScale
    const XiPartWidthHalf = XiPartWidth / 2
    const XiPartHeightHalf = XiPartHeight / 2
    let xi = 0
    let yi = 0
    let si = 0
    const xs = [
      140, 510, 310,
      620, 1200, 510,
      570, 1360, 1150,
      1400, 1530, 1200,
      1765, 810, 1645
    ]
    const ys = [
      160, 570, 610,
      400, 710, 210,
      710, 285, 240,
      580, 135, 480,
      490, 425, 680
    ]
    const big = X_NORMAL_WIDTH / X_NORMAL_WIDTH
    const small = X_SMALL_WIDTH / X_NORMAL_WIDTH
    const scales = [
      big, small, small,
      big, small, big,
      small, small, small,
      big, small, small,
      small, small / 2, big
    ]
    const genTargetX = () => {
      // return (0.5 - Math.random()) * canvasWidth
      return xs[xi++] - 1920 / 2
    }
    const genTargetY = () => {
      // return (0.5 - Math.random()) * canvasHeight
      return ys[yi++] - canvasHeight / 2 / global.scale
    }
    const genTargetScale = () => {
      // const min = X_SMALL_WIDTH / X_NORMAL_WIDTH
      // const max = X_NORMAL_WIDTH / X_NORMAL_WIDTH
      // return min + Math.random() * (max - min)
      return scales[si++]
    }
    const genTargetRotation = () => {
      return Math.random() * Math.PI * 2
    }
    const genTargetBlur = () => {
      return Math.random()
    }
    const alphaDistance = Math.sqrt(0.25 * canvasWidth * canvasWidth + 0.25 * canvasHeight * canvasHeight)
    for (let i = 0; i < 5; i++) {
      const yellow = new XiPart(context,
        -xWidthHalf + XiPartWidthHalf, -xHeightHalf + XiPartHeightHalf,
        IMG_YELLOW_WIDTH * initialScale, IMG_YELLOW_HEIGHT * initialScale,
        resource['x-yellow-3x'], resource['x-yellow-blurred'], IMG_YELLOW_WIDTH, IMG_YELLOW_HEIGHT,
        genTargetX(), genTargetY(), genTargetScale(), genTargetRotation(), genTargetBlur(),
        alphaDistance)
      const blue = new XiPart(context,
        0, 0,
        IMG_BLUE_WIDTH * initialScale, IMG_BLUE_HEIGHT * initialScale,
        resource['x-blue-3x'], resource['x-blue-blurred'], IMG_BLUE_WIDTH, IMG_BLUE_HEIGHT,
        genTargetX(), genTargetY(), genTargetScale(), genTargetRotation(), genTargetBlur(),
        alphaDistance)
      const red = new XiPart(context,
        xWidthHalf - XiPartWidthHalf, xHeightHalf - XiPartHeightHalf,
        IMG_RED_WIDTH * initialScale, IMG_RED_HEIGHT * initialScale,
        resource['x-red-3x'], resource['x-red-blurred'], IMG_RED_WIDTH, IMG_RED_HEIGHT,
        genTargetX(), genTargetY(), genTargetScale(), genTargetRotation(), genTargetBlur(),
        alphaDistance)
      this.add(yellow)
      this.add(blue)
      this.add(red)
      this.xs.push(yellow)
      this.xs.push(blue)
      this.xs.push(red)
    }
  }
}
